const ChaCha = {
    name: "Cha Cha",
    bpm: 100,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default ChaCha;